import React from 'react';
import Col from "react-bootstrap/Col";
import {observer} from "mobx-react";
import {useStores} from "../stores/Context";
import CreateIndicateur from "./createWidget/CreateIndicateur";
import CreateChoixType from "./createWidget/CreateChoixType";
import CreateMeteo from "./createWidget/CreateMeteo";
import CreateURL from "./createWidget/CreateURL";
import CreateYoutube from "./createWidget/CreateYoutube";
import CreateRSS from "./createWidget/CreateRSS";
import CreatePlanningActions from "./createWidget/CreatePlanningActions";
import CreateConsignes from "./createWidget/CreateConsignes";
import styles from "./createWidget/CreateForm.module.scss";
import CreateTableauBlanc from "./createWidget/CreateTableauBlanc";
import CreateRSP from "./createWidget/CreateRSP";
import WidgetBibliothequeImages from "./Widgets/WidgetBibliothequeImages/WidgetBibliothequeImages";

const CreateWidget = observer(() => {
    const {uiStore} = useStores();
    const {createWidgetStore} = useStores();

    const _typeWidget = createWidgetStore.typeWidget

    const loadWidgetForm = (typeWidget) => {
        switch (typeWidget) {
            case 'WidgetYoutube':
                return <CreateYoutube/>;
            case 'WidgetIndicateur':
                return <CreateIndicateur/>;
            case 'WidgetMeteo':
                return <CreateMeteo/>;
            case 'WidgetURL':
                return <CreateURL/>;
            case 'WidgetRss':
                return <CreateRSS/>;
            case 'WidgetPlanningActions':
                return <CreatePlanningActions/>;
            case 'WidgetBibliothequeImages':
                return <WidgetBibliothequeImages />;
            case 'WidgetConsignes':
                return <CreateConsignes/>;
            case 'WidgetRSP':
                return <CreateRSP/>;
            case 'WidgetTableauBlanc':
                return <CreateTableauBlanc/>;
            case '':
                return <CreateChoixType/>;
            default:
                return <CreateChoixType/>;
        }
    }

    return (
        <Col className={uiStore.isPanelOpened ? 'sidebarActive' : ''} style={{position: "relative"}}>
            <div
                className={`${styles.fondFormulairePhidget} ${uiStore.isPanelExtended ? styles.fondFormulaireWithLibrary : ''}`}
            >

                {(_typeWidget === '') ?
                    <CreateChoixType/>
                    : <div className={styles.rectangleFormulairePhidget}>
                        <div className={styles.containerFormulairePhidget}>{loadWidgetForm(_typeWidget)}</div>
                    </div>
                }


            </div>
        </Col>
    );
});

export default CreateWidget;
